import { render, staticRenderFns } from "./AccertamentiSupplementariDettagliEdit.vue?vue&type=template&id=4c78ce20"
import script from "./AccertamentiSupplementariDettagliEdit.vue?vue&type=script&lang=js"
export * from "./AccertamentiSupplementariDettagliEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports